export function isDefined<T>(x: T | undefined | null): x is T {
    return x != null;
}

export type WithPartialProps<TProps, K extends keyof TProps> = Omit<TProps, K> & Partial<Pick<TProps, K>>;

// eslint-disable-next-line @typescript-eslint/ban-types
export function isNotNullOrUndefined<T extends Object>(input: null | undefined | T): input is T {
    return input != null;
}